import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Spinner,
} from "reactstrap";
import { getDashboardNewSellers } from "../../api/ecommerce";
import { getApiOrigin } from "../../helpers/productImageUrl";

const placeholderAvatar = "https://via.placeholder.com/48?text=S";

const TopSellers = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getDashboardNewSellers(5)
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : data?.data || [];
        setRows(list);
      })
      .catch(() => {
        if (!cancelled) setRows([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const resolveImg = (src) => {
    if (!src) return placeholderAvatar;
    if (src.startsWith("http://") || src.startsWith("https://")) return src;
    const base = getApiOrigin();
    return `${base}${src.startsWith("/") ? "" : "/"}${src}`;
  };

  return (
    <React.Fragment>
      <Col xl={4}>
        <Card className="card-height-100">
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">New Sellers</h4>
            <div className="flex-shrink-0">
              <UncontrolledDropdown className="card-header-dropdown">
                <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                  <span className="text-muted">
                    Recent
                    <i className="mdi mdi-chevron-down ms-1"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu dropdown-menu-end">
                  <DropdownItem header>Newest registrations first</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </CardHeader>

          <CardBody>
            {loading ? (
              <div className="text-center py-5">
                <Spinner color="primary" /> Loading...
              </div>
            ) : (
              <div className="table-responsive table-card">
                <table className="table table-centered table-hover align-middle table-nowrap mb-0">
                  <tbody>
                    {rows.length === 0 ? (
                      <tr>
                        <td colSpan={3} className="text-muted text-center py-4">
                          No sellers yet.
                        </td>
                      </tr>
                    ) : (
                      rows.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 me-2">
                                <img
                                  src={resolveImg(item.img)}
                                  alt=""
                                  className="avatar-sm p-2 rounded"
                                  onError={(e) => {
                                    e.target.src = placeholderAvatar;
                                  }}
                                />
                              </div>
                              <div>
                                <h5 className="fs-14 my-1 fw-medium">
                                  <Link to={`/seller-details/${item.id}`} className="text-reset">
                                    {item.label}
                                  </Link>
                                </h5>
                                <span className="text-muted">{item.name || "—"}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="text-muted">{item.product} products</span>
                          </td>
                          <td className="text-end">
                            <span className="text-muted fs-12">
                              {item.created_at
                                ? new Date(item.created_at).toLocaleDateString()
                                : "—"}
                            </span>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
              <div className="col-sm">
                <div className="text-muted">
                  <Link to="/sellers" className="fw-semibold">
                    View all sellers
                  </Link>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default TopSellers;
